<template>
    <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
        <template slot="header">
            <th :class="StyleTh+' text-center'">#</th>
            <th :class="StyleTh">Folio</th>
            <th :class="StyleTh">Cliente</th>
            <th :class="StyleTh">RFC</th>
            <th :class="StyleTh">Forma de Pago</th>
            <th :class="StyleTh">Total</th>
            <th :class="StyleTh">Usuario</th>
            
            <th :class="StyleTh+' text-center'">Acciones</th>
        </template>

        <template slot="body">
            <tr v-for="(lista,index) in ListaArrayRows" :key="index">
                <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                <td><h6 :class="StylePr">{{lista.IdCotizacion}}</h6></td>
                    <td><p :class="StyleTd">{{lista.IdEmpresa}}</p></td>
                    <td><p :class="StyleTd">{{lista.IdCliente}}</p></td>
                    <td><p :class="StyleTd">{{lista.IdUsuario}}</p></td>
                    <td><p :class="StyleTd">{{lista.FechaRegistro}}</p></td>
                    <td><p :class="StyleTd">{{lista.FechaRegistro}}</p></td>
                   
                    
                <td class="align-middle text-end">
                    <CBtnAccion :pShowBtnEdit="true" :pShowBtnDelete="true" :pIsModal="false" :pId="lista.IdNotaVenta" :pEmitSeccion="ConfigList.EmitSeccion" :pGoRoute="ConfigList.GoRoute" :segurity="segurity" :pObj="ConfigList.Obj">
                        <template slot="btnaccion">
                            <button @click="VerPdfFactura(lista)" class="btn btn-link text-danger px-3 mb-0 mr-1">
                                <i class="fas fa-file-pdf text-danger me-2" aria-hidden="true"></i>PDF
                            </button>
                        </template>
                    </CBtnAccion>     
                </td>
            </tr>
            <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="8"></CSinRegistros>
        </template>
    </CList>

</template>
<script>

import moment from 'moment';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionNotaVenta';

export default {
    name: 'ListaNotaVenta',
    props:['pObjEnviado','pLugar'],
    components: {
    },
    data() {
        return {
            ConfigList:{
                Title: 'Cotización: ',
                IsModal: false,
                /*ShowYear: true,*/
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                TitleFirst: 'Notas de Venta',
                GoRoute: 'notaventaform',
                Obj: {},
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            ObjCotizacion: {},
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("notaVentas",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Eliminar(Id)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('notaVentas/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar(){
            this.$router.push({name:'cotzPendientes', params:{}});
        },
        VerPdfFactura(item)
        {
            this.ConfigList.ShowLoader = true;

            let newRequest = {
				IdNotaVenta: item.IdNotaVenta
			}

			this.$http.post('rptpdfVenta',newRequest).then((res)=>{     
				
				let pdfWindow = window.open("NotaVenta",'NotaVenta_'+item.IdNotaVenta,'_blank');
				pdfWindow.document.write(
					"<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
					encodeURI(res.data.pdf) + "'></iframe>"
				);
                
			}).catch(err=>{   
				console.log(err);
			}).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
    },
    created()
    {
        if(this.pLugar != undefined)
        {
            if(this.pObjEnviado != undefined){
                sessionStorage.setItem('objCotizacionNota',JSON.stringify(this.pObjEnviado));
            }

            this.ObjCotizacion = JSON.parse(sessionStorage.getItem('objCotizacionNota'));
            this.ConfigList.Title = this.ConfigList.Title+' '+this.ObjCotizacion.Folio;

            let obj = {
                objCotz: this.ObjCotizacion,
                Lugar: 'CotzxNota',
            };

            this.ConfigList.Obj = obj;
        }
        else
        {
            sessionStorage.removeItem('objCotizacionNota');
        }

        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>